import React, { type FC } from 'react';
import { DualTitleHeaderComponent } from '@zawarski/eti-typescript-components';
import { AssignedIncidentsListWrapper } from '@zawarski/palmetto-typescript-incidents';
import MenuIcon from '@mui/icons-material/Menu';
import { OnBoarding } from 'components/fragment';

interface Props {
  groupName: string;
  isInitialOnBoarding: boolean;
  onBoardingSettings: {
    isInitialized: boolean;
    hasUpdates: boolean;
    hasCheckedHide: boolean;
    programInFullScreen: string;
  };
  onCloseAssignedIncidents: () => void;
  onCloseOnBoarding: () => void;
  onOpenIncidentsTable: () => void;
  openAssignedIncidents: boolean;
  openOnBoarding: boolean;
  programsHistory: string[];
  programsList: Nullable<ISelectedPrograms[]>;
  token: string;
  username: string;
  dimensions: { width: number; height: number };
}

const DashboardInitial: FC<Props> = ({
  groupName,
  isInitialOnBoarding,
  onBoardingSettings,
  onCloseAssignedIncidents,
  onCloseOnBoarding,
  onOpenIncidentsTable,
  openAssignedIncidents,
  openOnBoarding,
  programsHistory,
  programsList,
  token,
  username,
  dimensions,
}) => {
  return (
    <>
      <DualTitleHeaderComponent
        titleBig={'Palmetto Dashboard'}
        titleSmall={`${username} - ${groupName}`}
        icon={<MenuIcon sx={{ color: 'white' }} />}
      />
      <div className='h-screen overflow-hidden' />
      <OnBoarding
        isInitialOnBoarding={isInitialOnBoarding}
        open={openOnBoarding}
        onClose={onCloseOnBoarding}
        onBoardingSettings={onBoardingSettings}
        programsList={programsList}
        programsHistory={programsHistory}
      />
      {openAssignedIncidents && (
        <AssignedIncidentsListWrapper
          dimensions={dimensions}
          onClose={onCloseAssignedIncidents}
          userAuth={{ jwt: token }}
          onOpenIncidentsTable={onOpenIncidentsTable}
        />
      )}
    </>
  );
};
export default DashboardInitial;
